<footer>
  <div class="footer-nav">
    <div class="container">
      <ul>
        <li><a class="btn-main-link" href="https://mind-berry.com/">Home</a></li>
        <li><a class="btn-main-link" href="https://mind-berry.com/myaccount">My Account</a></li>
        <li><a class="btn-main-link" href="https://mind-berry.com/contact">Contact Us</a></li>
      </ul>

      <div class="clear"></div>

      <div style="display: flex; justify-content: center; margin-top: 10px;">
        <a style="margin: 0 5px;" href="https://www.instagram.com/mindberrywellbeing/" target="_blank"><img style="width:36px;" src="/images/i.svg" /></a>
        <a style="margin: 0 5px;" href="https://www.facebook.com/mindberry" target="_blank"><img style="width:36px;" src="/images/f.svg" /></a>
        <a style="margin: 0 5px;" href="https://www.linkedin.com/company/mindberry-group" target="_blank"><img style="width:36px;" src="/images/l.svg" /></a>
        <a style="margin: 0 5px;" href="https://twitter.com/mindberrygroup" target="_blank"><img style="width:36px;" src="/images/x.svg" /></a>
      </div>
    </div>

    <div class="container">
      <div class="footer-icon"><a href="https://mind-berry.com/"><img src="/images/logo-main.png" /></a></div>
      <div class="footer-address">
        <p>
          MindBerry Group Limited,<br />
          Vision House, 3a Dee Road, Richmond, TW9 2JN
        </p>
      </div>
    </div>

    <div class="footer-legal-outer">
      <ul>
        <li><a href="https://mind-berry.com/terms-of-use">Terms of use</a></li>
        <li><a href="https://mind-berry.com/privacy-policy">Privacy Policy</a></li>
      </ul>
    </div>
  </div>
</footer>
